<template >
  <div class="RoomChoose" v-if="show" :class="{ loading: loading > 0 }">
    <h2 v-if="chooseRoom" class="title">{{ tran("CHOOSE_YOUR_ROOM") }}</h2>
    <h2 v-else class="title">{{ tran("UPDATE_YOURE_SELECTION") }}</h2>
    <div class="room-body" v-if="chooseRoom && item">
      <div class="room-left">
        <div class="wrapper">
          <div class="deck-locations">
            <div
              v-for="(location_name, id) in item.deck_locations"
              :key="id"
              v-html="location_name"
              :class="{ active: id == currentRoom.position?.toUpperCase() }"
            ></div>
          </div>
          <div
            class="room-info"
            :style="
              currentCategory.image
                ? 'background-image: url(' + currentCategory.image + ')'
                : ''
            "
          >
            <div
              class="view-gallery"
              @click.prevent="run('showGallery', currentCategory)"
              v-if="currentCategory.gallery && currentCategory.gallery.length"
            >
              <span class="fa fa-images"></span
              ><span v-html="tran('VIEW_GALLERY')"></span>
            </div>
            <h3><span v-html="currentCategory.title"></span></h3>
            <div
              class="change-room-category"
              @click.prevent="changeRoomCategory"
              v-if="run('get', 'numberOfRoom') > 1"
            >
              <span
                v-html="
                  tran('CHANGE_ROOM_CATEGORY', {
                    room: currentUserRoomIndex + 1,
                  })
                "
              ></span>
            </div>
            <div class="room-number">
              <div
                v-html="tran('ROOM_INDEX', { room: currentUserRoomIndex + 1 })"
              ></div>
              <div>
                <span>#</span><span v-text="currentRoom.roomNumber"></span>
              </div>
              <div>
                <a
                  @click.prevent="showDetail"
                  href="#"
                  v-html="tran('DETAILS')"
                ></a>
              </div>
            </div>
            <div
              class="room-area"
              v-html="currentRoom.totalArea ? currentRoom.totalArea : '&nbsp;'"
            ></div>
            <div class="deck-location" v-html="currentRoom.location"></div>

            <div class="room-price">
              <span v-html="currentCategory.price"></span>
            </div>

            <div class="buttons">
              <button
                id="choose-room-btn"
                type="button"
                class="btn btn-success"
                :disabled="!canNextRoom"
                @click.prevent="run('next')"
              >
                {{
                  nextRoomIndex > -1
                    ? tran("CONTINUE_NEXT_ROOM", nextRoomIndex + 1)
                    : tran("SELECT_CONTINUE")
                }}
              </button>
            </div>
          </div>

          <div class="deck-plan-key" v-html="item.desk_plan_key"></div>
        </div>
      </div>
      <div class="room-right">
        <div>
          <div class="tab-nav">
            <div>
              <div
                class="pointer"
                :class="{
                  active: viewMode == 'deck',
                  hidden: !currentDeck.deck_plan,
                }"
                v-html="tran('DECK_VIEW')"
                @click.prevent="viewMode = 'deck'"
              ></div>
              <div
                class="pointer"
                :class="{ active: viewMode == 'list' }"
                v-html="tran('LIST_VIEW')"
                @click.prevent="viewMode = 'list'"
              ></div>
            </div>
          </div>

          <div class="view-deck" v-if="viewMode == 'deck'">
            <div class="status-notes">
              <div class="status-available" v-html="tran('AVAILABLE')"></div>
              <div
                class="status-unavailable"
                v-html="tran('UNAVAILABLE')"
              ></div>
              <div
                class="status-previously"
                v-html="tran('PREVIOUSLY_SELECTED')"
              ></div>
              <div class="status-selected" v-html="tran('SELECTED')"></div>
              <div
                class="status-selected-other"
                v-html="tran('SELECTED_OTHER')"
                v-if="run('get', 'numberOfRoom') > 1"
              ></div>
            </div>
            <div class="deck-plan-container">
              <div class="user-rooms" v-if="run('get', 'numberOfRoom') > 1">
                <div
                  class="current-user-room pointer"
                  :class="
                    'current-user-room-' +
                    (index + 1) +
                    (index == currentUserRoomIndex ? ' active' : '') +
                    (userRooms[index].userChooseRoom &&
                    userRooms[index].roomNumber
                      ? ' complete'
                      : '')
                  "
                  v-for="(userRoom, index) in userRooms"
                  :key="index"
                  @click="run('set', 'currentUserRoomIndex', index)"
                >
                  <span>{{ tran("ROOM") }} {{ index + 1 }}</span
                  ><span class="fa fa-edit"></span>
                </div>
              </div>
              <div
                ref="deckPlan"
                class="deck-plan"
                v-if="currentDeck"
                v-html="currentDeck.deck_plan"
              ></div>
              <div v-else class="deck-plan"></div>
              <div class="deck-tab">
                <div v-html="tran('DECK')"></div>
                <div
                  v-for="(deck, index) in item.decks"
                  :key="index"
                  @click.prevent="currentDeck = deck"
                  class="pointer"
                  :class="{ active: currentDeck == deck }"
                >
                  <span v-html="deck.code"></span>
                </div>
              </div>
            </div>
          </div>
          <div class="view-deck" v-else-if="viewMode == 'list'">
            <div class="room-nav">
              <vSelect
                :options="listDecks"
                v-model="currentDeck"
                :clearable="false"
                label="title"
                class="none-search-select"
              >
              </vSelect>

              <div class="sort-rooms">
                <span v-html="tran('SORT_BY')"></span>
                <span
                  class="sort-price high-to-low"
                  v-if="sortPriceLowToHigh"
                  v-html="tran('PRICE_HIGH_TO_LOW')"
                  @click.prevent="sortPriceLowToHigh = !sortPriceLowToHigh"
                ></span>
                <span
                  class="sort-price low-to-high"
                  v-else
                  v-html="tran('PRICE_LOW_TO_HIGH')"
                  @click.prevent="sortPriceLowToHigh = !sortPriceLowToHigh"
                ></span>
              </div>
            </div>
            <div class="status-notes">
              <div
                class="status-previously"
                v-html="tran('PREVIOUSLY_SELECTED')"
              ></div>
              <div class="status-selected" v-html="tran('SELECTED')"></div>
              <div
                class="status-selected-other"
                v-html="tran('SELECTED_OTHER')"
                v-if="run('get', 'numberOfRoom') > 1"
              ></div>
            </div>
            <div class="room-list" v-if="currentDeck.code == 'all'">
              <div
                class="room-item pointer"
                :class="{
                  selected: currentRoom.roomNumber == r.roomNumber,
                  previously: lastRoomNumber == r.roomNumber,
                  'selected-other': otherRoomNumber.includes(r.roomNumber),
                }"
                v-for="(r, index) in roomAvailablesAll"
                :key="index"
                @click="selectRoom(r.roomNumber)"
                :disabled="otherRoomNumber.includes(r.roomNumber) ? '' : null"
              >
                <h4
                  class="room-title"
                  v-html="
                    r.title
                      ? r.title
                      : (currentCategory.title ?? '') + ' #' + r.roomNumber
                  "
                ></h4>
                <div class="room-desc">
                  <div class="left">
                    <div v-html="r.location"></div>
                    <div v-html="r.totalArea"></div>
                  </div>
                  <div class="price">
                    <div v-html="currentCategory.categoryPrice"></div>
                    <div v-html="tran('PRICE_PER_PERSON')"></div>
                  </div>
                </div>
              </div>
            </div>
            <div class="room-list" v-else>
              <div
                class="room-item pointer"
                :class="{
                  selected: currentRoom.roomNumber == r.roomNumber,
                  previously: lastRoomNumber == r.roomNumber,
                  'selected-other': otherRoomNumber.includes(r.roomNumber),
                }"
                v-for="(r, index) in roomAvailables"
                :key="index"
                @click="selectRoom(r.roomNumber)"
                :disabled="otherRoomNumber.includes(r.roomNumber) ? '' : null"
              >
                <h4
                  class="room-title"
                  v-html="
                    r.title
                      ? r.title
                      : (currentCategory.title ?? '') + ' #' + r.roomNumber
                  "
                ></h4>
                <div class="room-desc">
                  <div class="left">
                    <div v-html="r.location"></div>
                    <div v-html="r.totalArea"></div>
                  </div>
                  <div class="price">
                    <div v-html="currentCategory.price"></div>
                    <div v-html="tran('PRICE_PER_PERSON')"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="room-body all-rooms" v-else-if="!chooseRoom">
      <div class="user-room-items">
        <div
          class="user-room-item"
          v-for="(userRoom, index) in userRooms"
          :key="index"
        >
          <div class="room-guests-detail">
            <div v-html="tran('ROOM_INDEX', { room: index + 1 })"></div>
            <div
              v-html="
                tran(
                  'ROOM_GUEST_NUMBER' +
                    (userRoom.numberOfChildren > 0 ? '_CHILDREN' : ''),
                  {
                    numberOfAdults: userRoom.numberOfAdults,
                    numberOfChildren: userRoom.numberOfChildren,
                  }
                )
              "
            ></div>
          </div>
          <div
            class="room-info"
            :style="
              currentCategory.image
                ? 'background-image: url(' + currentCategory.image + ')'
                : ''
            "
          >
            <div
              class="view-gallery"
              @click.prevent="run('showGallery', currentCategory)"
              v-if="currentCategory.gallery && currentCategory.gallery.length"
            >
              <span class="fa fa-images"></span
              ><span v-html="tran('VIEW_GALLERY')"></span>
            </div>
            <h3><span v-html="userRoom.categoryTitle"></span></h3>

            <div class="room-number">
              <div v-html="tran('ROOM', index + 1)"></div>
              <div>
                <span>#</span><span v-text="userRoom.roomNumber"></span>
              </div>
              <div>
                <a
                  @click.prevent="showDetail"
                  href="#"
                  v-html="tran('DETAILS')"
                ></a>
              </div>
            </div>
            <div class="room-area" v-text="userRoom.totalArea"></div>
            <div class="deck-location" v-html="userRoom.location"></div>
            <a
              v-if="false"
              class="view-location"
              v-html="tran('VIEW_LOCATION')"
            ></a>

            <div class="room-price">
              <span v-html="userRoom.categoryPrice"></span>
            </div>
            <div class="buttons">
              <button
                id="change-room-btn"
                type="button"
                class="btn btn-link"
                :disabled="!validate()"
                @click.prevent="changeRoomCategory(index)"
                v-if="userRoom.guarantee"
              >
                {{ tran("CHANGE_ROOM") }}
              </button>
              <button
                id="change-room-btn"
                type="button"
                class="btn btn-link"
                :disabled="!validate()"
                @click.prevent="changeRoom(index)"
                v-if="!userRoom.guarantee"
              >
                {{ tran("CHANGE_ROOM") }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="buttons" v-if="!chooseRoom">
      <button
        id="next-step-offer-btn"
        type="button"
        class="btn btn-success"
        @click.prevent="
          showSelectedRooms = false;
          run('next');
        "
      >
        {{ tran("NEXT_STEP") }}
      </button>
    </div>
  </div>
</template>

<script>
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import { nextTick } from "vue";
export default {
  name: "RoomChoose",
  components: { vSelect },
  props: {
    run: Function,
  },
  data() {
    return {
      isShow: false,
      loading: 0,
      item: false,
      viewMode: "deck", //list
      currentDeck: undefined,
      lastRoomNumber: "",
      sortPriceLowToHigh: true,
      chooseRoom: true,
      reloadCategory: true,
      showSelectedRooms: false,
    };
  },
  mounted() {
    this.run("set", "groupStep." + this.$.type.name, "select_room");
    if (typeof this.validate == "function") {
      this.run("set", "validates." + this.$.type.name, this.validate);
    }
    if (typeof this.next == "function") {
      this.run("set", "nexts." + this.$.type.name, this.next);
    }
    if (typeof this.prev == "function") {
      this.run("set", "prevs." + this.$.type.name, this.prev);
    }
    if (this.show) {
      this.onShow();
    }
  },
  watch: {
    show(n) {
      if (n) {
        this.onShow();
      } else {
        this.onHide();
      }
    },
    viewMode(n) {
      if (n == "deck" && this.currentDeck?.code == "all") {
        const room = this.run("room");
        for (const deck of this.item.decks) {
          if (!room || room.deckCode == deck.code) {
            this.currentDeck = deck;
            return;
          }
        }
        this.currentDeck = this.item.decks[0];
        return;
      }
      this.uploadSvg();
    },
    currentDeck(n) {
      if (
        !this.currentDeck ||
        !this.currentDeck.deck_plan ||
        this.currentDeck.deck_plan.trim() == ""
      ) {
        this.viewMode = "list";
      }
      if (
        this.currentRoom &&
        this.roomNumberAvailablesAll.includes(this.currentRoom.roomNumber)
      ) {
        for (const k in n.rooms) {
          const room = n.rooms[k];
          if (this.currentRoom.roomNumber == room.roomNumber) {
            // room available
            this.selectRoom(room.roomNumber);
            // this.uploadSvg();
            return;
          }
        }
      }
      for (const roomNumber of this.roomNumberAvailables) {
        for (const k in n.rooms) {
          const room = n.rooms[k];
          if (this.otherRoomNumber.includes(roomNumber)) {
            continue;
          }
          if (roomNumber == room.roomNumber) {
            this.selectRoom(roomNumber);
            return;
          }
        }
      }
      if (!this.currentRoom.roomNumber) {
        for (const roomNumber of this.roomNumberAvailables) {
          if (this.otherRoomNumber.includes(roomNumber)) {
            continue;
          }
          this.selectRoom(roomNumber);
          return;
        }
      }

      this.uploadSvg();
    },
    currentUserRoomIndex() {
      if (!this.currentRoom) {
        return {};
      }
      if (!this.currentRoom || !this.currentRoom.categoryType) {
        this.run("goStep", this.run("stepIndex", "RoomCategory"), "next");
        return {};
      }
      this.uploadSvg();
    },
    sortPriceLowToHigh() {
      this.sortRooms();
    },
  },

  computed: {
    nextRoomIndex() {
      let nextRoomIndex = this.userRooms.length;
      for (const roomIndex in this.userRooms) {
        const room = this.userRooms[roomIndex];
        if (room.guarantee) {
          continue;
        }
        if (
          !room.userChooseRoom ||
          !room.roomNumber ||
          !room.category ||
          !room.categoryType
        ) {
          nextRoomIndex = roomIndex;
        }
      }
      if (this.currentUserRoomIndex > nextRoomIndex) {
        return nextRoomIndex;
      }
      let currentUserRoomIndex = this.currentUserRoomIndex + 1;
      while (currentUserRoomIndex < this.userRooms.length) {
        if (!this.userRooms[currentUserRoomIndex].guarantee) {
          return currentUserRoomIndex;
        }
        currentUserRoomIndex++;
      }

      return -1;
    },
    currentUserRoomIndex() {
      return this.run("get", "currentUserRoomIndex");
    },

    currentCategory() {
      if (!this.currentRoom || !this.currentRoom.categoryType) {
        return {};
      }

      const category = this.run(
        "get",
        "roomCategories." + this.currentRoom.categoryType,
        false
      );
      if (category) {
        return category;
      }
      if (this.reloadCategory) {
        this.fetchCateory();
        return {};
      }
      this.run("goStep", this.run("stepIndex", "RoomCategory"));
      return {};
    },
    userRooms() {
      return this.run("get", "rooms");
    },
    userRoomsList() {
      const rs = [];
      for (const roomIndex in this.userRooms) {
        rs.push({
          title: this.tran("ROOM_INDEX", { room: parseInt(roomIndex) + 1 }),
          value: parseInt(roomIndex),
        });
      }
      return rs;
    },
    listDecks() {
      return this.item.decks;
      // return [{ code: "all", title: "All" }, ...this.item.decks];
    },
    show() {
      return this.run("currentStep") == this.$.type.name;
    },
    data() {
      return this.run("get", "data");
    },
    otherRoomNumber() {
      const rooms = this.run("get", "rooms");
      const roomSelecteds = [];
      for (const roomIndex in rooms) {
        if (rooms[roomIndex].roomNumber == this.currentRoom.roomNumber) {
          continue;
        }
        roomSelecteds.push(rooms[roomIndex].roomNumber);
      }
      return roomSelecteds;
    },
    currentRoom() {
      const rooms = this.run("get", "rooms");
      return rooms[this.currentUserRoomIndex];
    },
    roomAvailables() {
      const roomAvailables = [];
      for (const k in this.item.rooms_available) {
        const room = this.item.rooms_available[k];
        if (room.deckCode != this.currentDeck?.code) {
          continue;
        }
        roomAvailables.push(room);
      }
      return roomAvailables;
    },
    roomNumberAvailables() {
      return this.roomAvailables.map((item) => item.roomNumber);
    },
    roomAvailablesAll() {
      const roomAvailables = [];
      for (const k in this.item.rooms_available) {
        const room = this.item.rooms_available[k];
        roomAvailables.push(room);
      }
      return roomAvailables;
    },
    roomNumberAvailablesAll() {
      return this.roomAvailablesAll.map((item) => item.roomNumber);
    },
    canNextRoom() {
      if (!this.currentRoom || !this.currentRoom.roomNumber) {
        return false;
      }
      return true;
    },
  },
  methods: {
    svgEventClick(e) {
      const roomNumber = e.target.id.replace(/^R/, "");
      if (!this.roomNumberAvailables.includes(roomNumber)) {
        return;
      }
      this.selectRoom(roomNumber);
    },
    svgEventOver(e) {
      e.target.classList.add("hover");
      this.$refs.deckPlan
        .querySelector("#T" + e.target.id.replace(/^R/, ""))
        .classList.add("hover");
    },
    svgEventleave(e) {
      e.target.classList.remove("hover");
      this.$refs.deckPlan
        .querySelector("#T" + e.target.id.replace(/^R/, ""))
        .classList.remove("hover");
    },
    async uploadSvg() {
      await nextTick();
      const svg = this.$refs.deckPlan?.querySelector("svg");
      if (!svg) {
        return;
      }
      const roomEls = svg.querySelectorAll(".cabinShape");
      const rooms = this.run("get", "rooms");

      roomEls.forEach((el) => {
        const roomNumber = el.id.replace(/^R/, "");
        const elText = svg.querySelector("#T" + roomNumber);
        elText.classList.remove(
          "available",
          "unavailable",
          "selected",
          "previously",
          "selected-other",
          "selected-1",
          "selected-2",
          "selected-3"
        );
        el.classList.remove(
          "available",
          "unavailable",
          "selected",
          "previously",
          "selected-other",
          "selected-1",
          "selected-2",
          "selected-3"
        );
        for (const roomIndex in rooms) {
          const room = rooms[roomIndex];
          if (
            roomIndex != this.currentUserRoomIndex &&
            room.roomNumber == roomNumber
          ) {
            el.classList.add(
              "selected-" + (parseInt(roomIndex) + 1),
              "selected-other"
            );
            elText.classList.add(
              "selected" + (parseInt(roomIndex) + 1),
              "selected-other"
            );
          }
        }

        el.removeEventListener("click", this.svgEventClick);
        el.removeEventListener("mouseover", this.svgEventOver);
        el.removeEventListener("mouseleave", this.svgEventleave);

        if (this.roomNumberAvailables.includes(roomNumber)) {
          if (this.currentRoom && this.currentRoom.roomNumber == roomNumber) {
            el.classList.add("selected");
            elText.classList.add("selected");

            el.addEventListener("click", this.svgEventClick);
            el.addEventListener("mouseover", this.svgEventOver);
            el.addEventListener("mouseleave", this.svgEventleave);
          } else if (!this.otherRoomNumber.includes(roomNumber)) {
            el.classList.add("available");
            elText.classList.add("available");

            el.addEventListener("click", this.svgEventClick);
            el.addEventListener("mouseover", this.svgEventOver);
            el.addEventListener("mouseleave", this.svgEventleave);
          }
        } else {
          el.classList.add("unavailable");
          elText.classList.add("unavailable");
        }
      });
      const selected = svg.querySelector(".cabinShape.selected");
      if (!selected) {
        return;
      }
      const rect = selected.getBoundingClientRect();
      const container = document.querySelector(
        ".RoomChoose .deck-plan-container .deck-plan"
      );
      if (!container) {
        return;
      }
      const containerRect = container.getBoundingClientRect();

      if (
        rect.top -
          containerRect.top +
          (window.pageYOffset || document.documentElement.scrollTop) >=
          0 &&
        rect.bottom + container.scrollTop - containerRect.top <=
          containerRect.height &&
        rect.bottom + container.scrollTop <=
          (rect.innerHeight || document.documentElement.clientHeight)
      ) {
        return;
      }

      container.scroll({
        top:
          container.scrollTop +
          rect.top -
          container.getBoundingClientRect().top -
          100,
        behavior: "smooth",
        block: "nearest",
        inline: "center",
      });
    },
    getRoom(roomNumber) {
      for (const k in this.item.decks) {
        const deck = this.item.decks[k];
        for (const j in deck.rooms) {
          if (roomNumber == deck.rooms[j].roomNumber) {
            return deck.rooms[j];
          }
        }
      }
    },
    selectRoom(roomNumber) {
      if (this.otherRoomNumber.includes(roomNumber)) {
        return;
      }
      let room;
      for (const k in this.item.rooms_available) {
        if (this.item.rooms_available[k].roomNumber == roomNumber) {
          room = this.item.rooms_available[k];
        }
      }
      if (!room) {
        return;
      }
      if (room.fetchDetail) {
        this._fetchCabinDetail(room);
      }
      room = {
        categoryTitle: this.currentCategory.title,
        ...this.currentRoom,
        ...(this.getRoom(roomNumber) ?? {}),
        ...room,
      };
      if (this.currentRoom && this.currentRoom.roomNumber != roomNumber) {
        this.lastRoomNumber = this.currentRoom.roomNumber;
      }
      this.run("set", "rooms." + this.currentUserRoomIndex, room);
      this.uploadSvg();
    },
    tran(key, replaces) {
      return this.run("tran", key, replaces);
    },
    onShow() {
      if (this.run("stepDirection") == "prev" && this.userRooms.length > 1) {
        this.run("set", "currentUserRoomIndex", this.userRooms.length - 1);
        this.chooseRoom = false;
        this.run("set", "chooseRoom", false);
        this.showSelectedRooms = true;
        return;
      }
      const guarantee = this.run(
        "get",
        "rooms." + this.currentUserRoomIndex + ".guarantee",
        false
      );
      if (guarantee) {
        const room = {
          categoryTitle: this.currentCategory.title,
          ...this.currentRoom,
          roomNumber: "GTY",
          userChooseRoom: true,
          location: "",
          totalArea: "",
          position: "",
          deckCode: "",
        };
        this.run("set", "rooms." + this.currentUserRoomIndex, room);
        if (this.run("stepDirection") == "prev") {
          this.run("prev");
        } else {
          this.run("next");
        }
        return;
      }
      this.chooseRoom =
        this.run("get", "chooseRoom", false) || this.nextRoomIndex != -1;
      this.run("set", "chooseRoom", false);
      this.fetch();
    },
    onHide() {},
    // prev(){},
    next() {
      this.run(
        "set",
        `rooms.${this.currentUserRoomIndex}.userChooseRoom`,
        true
      );
      if (
        this.userRooms[this.nextRoomIndex] &&
        this.userRooms[this.nextRoomIndex].guarantee
      ) {
        this.run("next");
        return false;
      }
      if (this.showSelectedRooms) {
        this.run("set", "currentUserRoomIndex", this.userRooms.length - 1);
        this.chooseRoom = false;
        return false;
      }

      if (this.nextRoomIndex > -1) {
        this.run("set", "currentUserRoomIndex", this.nextRoomIndex);
        if (this.currentRoom.categoryType) {
          this.fetch();
        }
        return false;
      }
      this.chooseRoom = false;
      this.run("set", "currentUserRoomIndex", 0);
      this.run("set", "chooseRoom", false);
      return true;
    },

    async fetch() {
      this.loading++;
      const rooms = this.run("rooms");
      const numberOfRoom = this.run("numberOfRoom");
      const ship = this.run("get", "ship");
      const roomIndex = this.run("get", "currentUserRoomIndex");
      const res = await this.run(
        "fetch",
        "index.php?option=com_cruise&task=" +
          this.run("get", "config.task", "booking") +
          ".getCabins",
        {
          rooms,
          numberOfRoom,
          roomIndex,
          shipCode: ship.shipCode,
          packageId: ship.packageId,
          sailDate: ship.sailDate,
        }
      );
      if (!res.success) {
        this.run("showMessage", res.message ?? "error", res.messageType);
        this.loading--;
        this.run("goStep", this.run("stepIndex", "RoomCategory"));
        return;
      }
      this.item = res.data;

      if (this.item.rooms) {
        this.run("set", "rooms", this.item.rooms);
      }
      this.sortRooms();

      for (const deck of this.item.decks) {
        if (!this.currentRoom || this.currentRoom.deckCode == deck.code) {
          this.currentDeck = deck;
          break;
        }
      }
      if (!this.currentDeck) {
        this.currentDeck = this.item.decks[0];
      }
      if (this.currentRoom) {
        let hasRoom = false;
        for (const roomAvailable of this.item.rooms_available) {
          if (roomAvailable.roomNumber == this.currentRoom.roomNumber) {
            hasRoom = true;
            this.selectRoom(roomAvailable.roomNumber);
            break;
          }
        }
        if (!hasRoom) {
          for (const deck of this.item.decks) {
            this.currentDeck = deck;
            for (const roomAvailable of this.roomAvailables) {
              if (!this.otherRoomNumber.includes(roomAvailable.roomNumber)) {
                this.selectRoom(roomAvailable.roomNumber);
                hasRoom = true;
                break;
              }
            }
            if (hasRoom) {
              break;
            }
          }
        }
      }

      this.loading--;
      // this.fetchCabinDetail();
    },
    async fetchCateory() {
      this.reloadCategory = false;
      this.loading++;
      const rooms = this.run("rooms");
      const numberOfRoom = this.run("numberOfRoom");
      const ship = this.run("get", "ship");
      const roomIndex = this.run("get", "currentUserRoomIndex");
      const res = await this.run(
        "fetch",
        "index.php?option=com_cruise&task=" +
          this.run("get", "config.task", "booking") +
          ".getRoomCategories",
        {
          numberOfRoom,
          rooms,
          roomIndex,
          shipCode: ship.shipCode,
          packageId: ship.packageId,
          sailDate: ship.sailDate,
        }
      );
      if (!res.success) {
        this.run(
          "showMessage",
          res.message ?? "error",
          res.messageType,
          res.exitBooking,
          res.buttonLabel
        );
        this.loading--;
        this.run("goStep", this.run("stepIndex", "RoomCategory"));
        return;
      }
      this.datas = res.data.items;
      this.items = res.data.items;
      for (const cat of res.data.items) {
        for (const c of cat.children) {
          this.run("set", "roomCategories." + c.value, c);
        }
      }
      this.loading--;
    },

    validate() {
      const rooms = this.run("rooms");
      for (const room of rooms) {
        if (!room.categoryType) {
          return false;
        }
      }
      return true;
    },

    showDetail() {
      this.run("setRoot", "modalData", this.currentCategory.detail);
      this.run("setRoot", "modalDataClass", "v-modal-large");
    },
    changeRoomCategory(index) {
      if (index != undefined) {
        this.run("set", "currentUserRoomIndex", index);
      }
      this.run("goStep", this.run("stepIndex", "RoomCategory"));
    },
    sortRooms() {
      this.item.rooms_available.sort((a, b) => {
        return this.sortPriceLowToHigh
          ? a.priceNumber - b.priceNumber
          : b.priceNumber - a.priceNumber;
      });
    },
    changeRoom(index) {
      this.chooseRoom = true;
      this.run("set", "currentUserRoomIndex", index);
      this.fetch();
    },
    async fetchCabinDetail() {
      let cabins = this.roomAvailables.filter((item) => item.fetchDetail);
      if (!cabins.length) {
        cabins = this.roomAvailablesAll.filter((item) => item.fetchDetail);
      }
      if (!cabins.length) {
        return;
      }
      this._fetchCabinDetail(cabins[0]);

      this.fetchCabinDetail();
    },
    async _fetchCabinDetail(cabin) {
      cabin.fetchDetail = false;
      const res = await this.run(
        "fetch",
        "index.php?option=com_cruise&task=" +
          this.run("get", "config.task", "booking") +
          ".getCabinDetail",
        {
          cabinNumber: cabin.roomNumber,
        }
      );
      if (res && res.success) {
        cabin.totalArea = res.data.totalArea;
        if (this.currentRoom.roomNumber == cabin.roomNumber) {
          this.currentRoom.fetchDetail = false;
          this.currentRoom.totalArea = res.data.totalArea;
        }
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
